export default "__VITE_ASSET__CPpB5oUy__"